import { createGesture, Gesture } from "@ionic/core";
import { Board, BoardTicket } from "./boards.page";
import { ChangeDetectorRef, ViewChild } from "@angular/core";
import * as signalR from "@microsoft/signalr";
import { SocketsService } from "src/app/_provider/sockets.service";
import { BoardService } from "src/app/_provider/boards/board.service";
import { IonContent } from "@ionic/angular";
import { BehaviorSubject } from "rxjs";

export abstract class BoardsGestures{

  protected dropableElements: Element[] = []
  protected dropableBoardLines: Element[] = []
  protected hiddenBoards: Element[] = []
  protected ionContent: IonContent

  public ionContentScrollDetails: {currentX: number, currentY: number} = {currentX: 0, currentY: 0}
  public onDrag: boolean = false;
  private ionContentStartX: number = 0;

  public scrollIndicatorTriggered: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(
      public boardSrv: BoardService,
      public changeDetector: ChangeDetectorRef,
      public socketSrv: SocketsService,
  ){}

  private indicatorScrollActive: boolean = false;
  private indicatorInterval: any;
  private indicatorScrollPx: number = 0;

  protected async detectIndicator(event: MouseEvent | TouchEvent){

    let clientX: number = 0;
    if(event instanceof TouchEvent) clientX = event.touches[0].clientX;
    else clientX = event.clientX;
    
    const ionContentScrollElement = await this.ionContent.getScrollElement();
    const ionContentWidth: number = ionContentScrollElement.getBoundingClientRect().width
    
    const scrollWidth: number = ionContentScrollElement.scrollWidth;
    const maxScrollLeft: number = scrollWidth - ionContentWidth;

    const mouseX: number = clientX - 50

    if(this.onDrag && (ionContentWidth - mouseX) <= 80){
      //Indicator rechte seite
      this.indicatorScrollPx = Math.floor((50 - (ionContentWidth - mouseX)) * 3.5);
      if(!this.indicatorScrollActive){
        this.indicatorScrollActive = true;
        this.indicatorInterval = setInterval(() => {
          let newScrollX: number = this.ionContentScrollDetails.currentX + Math.max(this.indicatorScrollPx, 0);
          this.ionContent.scrollToPoint(newScrollX >= maxScrollLeft ? maxScrollLeft : newScrollX, this.ionContentScrollDetails.currentY, 200)
          this.scrollIndicatorTriggered.next(this.ionContentScrollDetails.currentX - this.ionContentStartX)
        }, 100);
      }
    } else if(this.onDrag && mouseX <= 80){
      //Indicator linke seite
      this.indicatorScrollPx = Math.floor((50 - mouseX) * 3.5);
      if(!this.indicatorScrollActive){
        this.indicatorScrollActive = true;
        this.indicatorInterval = setInterval(() => {
          let newScrollX: number = this.ionContentScrollDetails.currentX - Math.max(this.indicatorScrollPx, 0);
          this.ionContent.scrollToPoint(newScrollX < 0 ? 0 : newScrollX, this.ionContentScrollDetails.currentY, 200)
          this.scrollIndicatorTriggered.next( this.ionContentScrollDetails.currentX - this.ionContentStartX)
        }, 100);
      }
    } else {
      this.indicatorScrollActive = false
      clearInterval(this.indicatorInterval)
    }
  }

  /**
   * Verschieben von den Boards
   */
  protected initBoardDragGesture(){
    const nativeBoards = Array.from(document.querySelectorAll(".wrapper-label"))
    nativeBoards.forEach((nativeElement: any)=>{
      const gesture: Gesture = createGesture({
        el: nativeElement,
        gestureName: "draggableBoards",
        direction: "x",
        threshold: 0,
        onStart: (event) => {
          nativeElement.style.transition = 'none';
          nativeElement.style.opacity = '0.7';
          nativeElement.style.zIndex = '99';
        },
        onMove: (ev) => {
            nativeElement.style.transform = `translate(${ev.deltaX}px)`;
            this.dropableBoardLines.forEach((dropLine: any)=>{
              const dropLineRect = dropLine.getBoundingClientRect();
              if(ev.currentX > (dropLineRect.right - 80) && ev.currentX < (dropLineRect.right + 80)) dropLine.classList.add("activeLine")
              else dropLine.classList.remove("activeLine")
            })
        },
        onEnd: (event: any) => {

          const dropElement: Element = this.dropableBoardLines.find(el => el.classList.contains("activeLine"))
          if(dropElement){
            let toIndex: number = +(dropElement as any).dataset.sectionvalue

            if(+nativeElement.dataset.sectionvalue >= toIndex) toIndex = toIndex
            else toIndex--

            const deletedItem: Board = this.boardSrv.boards.splice(nativeElement.dataset.sectionvalue, 1)[0]
            this.boardSrv.boards.splice(toIndex, 0, deletedItem);
            nativeElement.style = ""
            this.changeDetector.detectChanges()
            dropElement.classList.remove("activeLine")
            this.dropableBoardLines = Array.from(document.querySelectorAll(".board-drop-line"))
            this.boardSrv.reorderBoards()
          }else{
            nativeElement.style.transition = '.3s ease-out';
            nativeElement.style.transform = `translate( 0)`;
            setTimeout(() => {
              nativeElement.style.transition = 'inherit';
              nativeElement.style.zIndex = '3';
              nativeElement.style.opacity = '';
            }, 300);
          }
        }
      })
      gesture.enable()
    })
  }

  public async itemDragStart(event: {event: any, element: any}){
    this.ionContentStartX = this.ionContentScrollDetails.currentX;
  }

  /**
   * Überprüft, ob das Element über einem ablegbaren Element, einem versteckten Board oder einem Board-Header liegt und fügt entsprechende CSS-Klassen hinzu oder entfernt sie.
   * @param event - Ein Objekt, das das Ereignis und das Element enthält, das überprüft werden soll.
   * @returns Eine Promise, die das Ergebnis der Überprüfung zurückgibt.
   */
  public async checkIsOverAnyDropable(event: {event: any, element: any}){

    this.onDrag = true;
    
    const gestureRect = event.element.getBoundingClientRect()

    //Schauen ob es über einer versteckten Gruppe ist
    this.hiddenBoards.forEach((hb: Element)=>{
      const hbRect = hb.getBoundingClientRect()
      if(
        ((event.event.currentY - 40) < hbRect.top && (event.event.currentY + 5) > hbRect.top ) &&
        gestureRect.left <= hbRect.right - (hbRect.width / 2)  &&
        gestureRect.right >= hbRect.left + (hbRect.width / 2) 
      )
        return hb.classList.add("active-hidden-group")
      else hb.classList.remove("active-hidden-group")
    })

    //schauen ob es über einem drop element ist
    this.dropableElements.forEach((dropableElem: Element)=>{
      const otherElementRect = dropableElem.getBoundingClientRect();
      if(
        ((event.event.currentY - 50) < otherElementRect.top && (event.event.currentY + 50) > otherElementRect.top ) &&
        gestureRect.left <= otherElementRect.right - (otherElementRect.width / 2)  &&
        gestureRect.right >= otherElementRect.left + (otherElementRect.width / 2) 
      )
        dropableElem.classList.add("dragOver")
      else dropableElem.classList.remove("dragOver")
    })

    //Schauen ob es über board header ist 
    const boardHeader = Array.from(document.querySelectorAll(".wrapper-label"))
    boardHeader.forEach((bh: Element)=>{
      const bhRect = bh.getBoundingClientRect()
      if(
        ((event.event.currentY - 40) < bhRect.top && (event.event.currentY + 5) > bhRect.top ) &&
        gestureRect.left <= bhRect.right - (bhRect.width / 2)  &&
        gestureRect.right >= bhRect.left + (bhRect.width / 2.5) 
      ){
        this.dropableElements.forEach((dropableElem: Element)=>dropableElem.classList.remove("dragOver"))
        return bh.classList.add("active-board-header")
      }
      else bh.classList.remove("active-board-header")
    })
  }


  /**
   * Verschiebt ein BoardTicket von einem Board zu einem anderen Board oder innerhalb des gleichen Boards.
   * @param event - Das Drag-Event, das ausgelöst wurde.
   * @param domElement - Das DOM-Element, das verschoben wird.
   * @param element - Das BoardTicket-Objekt, das verschoben wird.
   */
  public async itemDragEnd(event: {event: any, domElement: any, element: BoardTicket}){

    this.onDrag = false;
    this.ionContentStartX = 0;

    //Wenn über hidden Board ist
    const dropHiddenElement: Element = this.hiddenBoards.find(el => el.classList.contains("active-hidden-group"))
    if(dropHiddenElement){
      let toBoardId: number = +(dropHiddenElement as any).dataset.sectionvalue
      const currentBoard: Board = this.boardSrv.boards.find(b =>{
        if(b.tickets.find(t => t.id == event.element.id)) return true
        else return false
      })
      const deletedTicket: BoardTicket = currentBoard.tickets.splice(currentBoard.tickets.indexOf(event.element), 1)[0]

      const newBoard: Board = this.boardSrv.boards.find(b => b.id == toBoardId)
      newBoard.tickets.push(deletedTicket)
      newBoard.ticketCount++
      currentBoard.ticketCount--

      dropHiddenElement.classList.remove("active-hidden-group")
      this.boardSrv.updateTicketPosition(event.element.id, newBoard.tickets.length , newBoard.id)
      this.invokeTicketPosition(event.element.id, newBoard.id, newBoard.tickets.length) 
      return
    }

    //Wenn es über board header ist
    const boardHeader: Element = Array.from(document.querySelectorAll(".wrapper-label")).find(el => el.classList.contains("active-board-header"))
    if(boardHeader){
      let toBoardId: number = +(boardHeader as any).dataset.boardid
      const currentBoard: Board = this.boardSrv.boards.find(b =>{
        if(b.tickets.find(t => t.id == event.element.id)) return true
        else return false
      })
      const deletedTicket: BoardTicket = currentBoard.tickets.splice(currentBoard.tickets.indexOf(event.element), 1)[0]
      const newBoard: Board = this.boardSrv.boards.find(b => b.id == toBoardId)

      newBoard.tickets.push(deletedTicket)
      newBoard.ticketCount++
      currentBoard.ticketCount--
      this.changeDetector.detectChanges()

      boardHeader.classList.remove("active-board-header")
      this.boardSrv.updateTicketPosition(event.element.id, newBoard.tickets.length , newBoard.id)
      this.invokeTicketPosition(event.element.id, newBoard.id, newBoard.tickets.length) 
      return
    }

    //Wenn es über drop Elelemtn ist
    const dropElement: Element = this.dropableElements.find(el => el.classList.contains("dragOver"))
    if(dropElement){

      let toIndex: number = +(dropElement as any).dataset.sectionvalue
      
      const dropBoard: Board = this.boardSrv.boards[+(dropElement as any).dataset.boardnumber]
      const currentBoard: Board = this.boardSrv.boards.find(b =>{
        if(b.tickets.find(t => t.id == event.element.id)) return true
        else return false
      })

      if(dropBoard.id == currentBoard.id && currentBoard.tickets.indexOf(event.element) < toIndex) toIndex--

      const deletedItem: BoardTicket = currentBoard.tickets.splice(currentBoard.tickets.indexOf(event.element), 1)[0]
      dropBoard.tickets.splice(toIndex, 0, deletedItem)

      dropBoard.ticketCount++
      currentBoard.ticketCount--

      //Style zurücksetzen
      event.domElement.style.transition = '.3s ease-out';
      event.domElement.style.transform = `translate(0, 0)`;
      setTimeout(() => {
        event.domElement.style.zIndex = 'inherit';
        event.domElement.style.opacity = '';
      }, 300);

      dropElement.classList.remove("dragOver")
      this.changeDetector.detectChanges()
      this.dropableElements = Array.from(document.querySelectorAll('.board-wrapper-dropable'))
      this.boardSrv.updateTicketPosition(event.element.id, toIndex, dropBoard.id)
      this.invokeTicketPosition(event.element.id, dropBoard.id, toIndex) 

    }else{
      event.domElement.style.transition = '.3s ease-out';
      event.domElement.style.transform = `translate(0, 0)`;
      setTimeout(() => {
        event.domElement.style.zIndex = 'inherit';
        event.domElement.style.opacity = '';
      }, 300);
    }
  } 

  protected async invokeTicketPosition(ticketId: number, boardId: number, position: number){
    if(this.socketSrv.socketState != signalR.HubConnectionState.Connected) await this.socketSrv.initializeSocket()
    await this.socketSrv.invoke("BoardItemChanged", ticketId, boardId, position)
  }

}